import { MutableRefObject, useEffect } from 'react'

export function useUnmountApp(ref: MutableRefObject<HTMLElement | null>) {
  useEffect(() => {
    const container = ref.current

    if (!container) return

    return () => {
      unmountApp(container)
    }
  }, [ref])
}

export const unmountApp = (container: HTMLElement | null) => {
  if (!container) return
  container.replaceChildren()
}
